export default [
  {
    id: 1,
    name: '德格版',
    contents: [
      { sutraId: 1 },
    ],
    verImg: '/static/image/content/versionPage/version01intro.png',
    introImg: '/static/image/content/versionPage/version01intro.png',
    introPageImg: '/static/image/content/indexBook.png',
    introPageTranslator: '/static/image/content/introPage/v1-translator.png',
    introPageStory: '/static/image/content/introPage/v1-story.png',
    bookCover: '/static/image/content/bookCoverV1.png',
  },
  {
    id: 2,
    name: '八十華嚴',
    contents: [
      { sutraId: 1 },
    ],
    verImg: '/static/image/content/versionPage/version02intro.png',
    introImg: '/static/image/content/versionPage/version02intro.png',
    introPageImg: '/static/image/content/indexBook.png',
    introPageTranslator: '/static/image/content/introPage/v2-translator.png',
    introPageStory: '/static/image/content/introPage/v2-story.jpeg',
    bookCover: '/static/image/content/bookCoverV2.png',
  },
  {
    id: 3,
    name: '六十華嚴',
    contents: [
      { sutraId: 1 },
    ],
    verImg: '/static/image/content/versionPage/version03intro.png',
    introImg: '/static/image/content/versionPage/version03intro.png',
    introPageImg: '/static/image/content/indexBook.png',
    introPageTranslator: '/static/image/content/introPage/v3-translator.png',
    introPageStory: '/static/image/content/introPage/v3-story.png',
    bookCover: '/static/image/content/bookCoverV3.png',
  },
  {
    id: 4,
    name: '諸菩薩求佛本業經',
    contents: [
      { sutraId: 1 },
    ],
    verImg: '/static/image/content/versionPage/version04intro.png',
    introImg: '/static/image/content/versionPage/version04intro.png',
    introPageImg: '/static/image/content/indexBook.png',
    introPageTranslator: '/static/image/content/introPage/v4-translator.png',
    introPageStory: '/static/image/content/introPage/v4-story.png',
    bookCover: '/static/image/content/bookCoverV4.png',
  },
  {
    id: 5,
    name: '佛說菩薩本業經',
    contents: [
      { sutraId: 1 },
    ],
    verImg: '/static/image/content/versionPage/version05intro.png',
    introImg: '/static/image/content/versionPage/version05Intro.png',
    introPageImg: '/static/image/content/indexBook.png',
    introPageTranslator: '/static/image/content/introPage/v5-translator.png',
    introPageStory: '/static/image/content/introPage/v5-story.png',
    bookCover: '/static/image/content/bookCoverV5.png',
  },
];



// WEBPACK FOOTER //
// ./src/components/data/versionData.js